import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface DeleteBlockDialogProps {
  open: boolean;
  blockName: string;
  /**
   * HW-685: true when the block holds stored employee data. The backend rejects
   * deletion (409) in that case, so we disable Delete and steer the user to clear
   * the fields first instead of promising a cascade the server will refuse.
   */
  hasStoredData?: boolean;
  isDeleting?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function DeleteBlockDialog({
  open,
  blockName,
  hasStoredData = false,
  isDeleting = false,
  onOpenChange,
  onConfirm,
}: DeleteBlockDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete &ldquo;{blockName}&rdquo;?</AlertDialogTitle>
          <AlertDialogDescription>
            {hasStoredData
              ? 'This block has fields with stored employee data, so it can’t be deleted yet. Delete its fields first (which clears the values they hold), then delete the block.'
              : 'This removes the block from every employee profile. Block fields and any data they hold will be removed too.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={isDeleting || hasStoredData}
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
